import angular from 'angular';
import indexMetricIndex from './index-metric-index.component';

export default angular.module('eshq.indexMetricIndex', [])
  .component('eshqIndexMetricIndex', indexMetricIndex)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-index/index-metric-index.js